import { getNumberedStepsTemplate, getVueNumberedStepsTemplate } from "../../shortcodes/templates";

const DATA_ATTR = "data-numbered-steps-data";

const visualizeNumberedSteps = content => {
  content.querySelectorAll('[data-wrapper-id="numbered-steps"]').forEach(item => {
    item.innerHTML = getNumberedStepsTemplate();
  });
};

const serializeNumberedSteps = content => {
  content.querySelectorAll('[data-wrapper-id="numbered-steps"]').forEach(item => {
    item.innerHTML = getVueNumberedStepsTemplate(item.getAttribute(DATA_ATTR));
  });
};

export { visualizeNumberedSteps, serializeNumberedSteps };
